import MileageSettingsUpdateRequest, {
  MileageSettingsUpdateRequestBody,
} from "./mileage-settings-update.request";

const createBody = (
  request: MileageSettingsUpdateRequest,
): MileageSettingsUpdateRequestBody => {
  return {
    isCardNoRequired: request.isCardNumberRequired,
    isMileageNoRequired: request.isMileageNumberRequired,
    mileageNoCreationType: request.mileageNumberCreationType,
  };
};

const mileageSettingsUpdateRequestFactory = {
  createBody,
};

export default mileageSettingsUpdateRequestFactory;
